import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import { basketStore } from "../store";
import type { BasketStore } from "../store.types";
import { getBasket } from "../getters";

export function useBasket(): BasketStore {
  return useStore(basketStore, useShallow(getBasket));
}

export function useOrderDiscount(): BasketStore["orderDiscount"] {
  return useStore(basketStore, (state) => state.orderDiscount);
}

export function useDiningOption(): BasketStore["diningOption"] {
  return useStore(basketStore, (state) => state.diningOption);
}

export function useShopperName(): BasketStore["shopperName"] {
  return useStore(basketStore, (state) => state.shopperName);
}

export function useActiveCategoryId(): BasketStore["activeCategoryId"] {
  return useStore(basketStore, (state) => state.activeCategoryId);
}

export function useIsCardPaymentRecovering(): boolean {
  return useStore(basketStore, (state) => state.isCardPaymentRecovering);
}

export function useIsBasketEmpty(): boolean {
  return useStore(basketStore, (state) => state.products.length === 0);
}
